import { makeDefaultRecord } from '@scentregroup/shared/helpers/utils'

import {
  ContentfulHit,
  Segment,
  MarketplaceHit,
  GroupAndRenderSegmentsArgs,
  GroupedHit,
  HitsGroup,
} from '../types'

interface ExtraArgs {
  headingsToDisplay: string[]
  getHeadingForSegment: (segment: Segment) => string
}

export default function groupSegmentsByHeading({
  segmentHits,
  context,
  onResultClickHeading,
  headingsToDisplay,
  getHeadingForSegment,
  mkpCartCount,
}: GroupAndRenderSegmentsArgs & ExtraArgs): HitsGroup[] {
  const resultsByHeadings: Record<
    string,
    GroupedHit[]
  > = makeDefaultRecord(() => [])
  ;(Object.keys(segmentHits) as Segment[]).forEach(segment => {
    const hits = segmentHits[segment]
    if (hits) {
      const heading = getHeadingForSegment(segment)
      const onResultClick = (hit: ContentfulHit | MarketplaceHit): void =>
        onResultClickHeading(heading, hit)
      const groupedHits = hits.map(hit => ({
        segment,
        hit,
        onResultClick,
        context,
        mkpCartCount,
      }))
      resultsByHeadings[heading].push(...groupedHits)
    }
  })
  return headingsToDisplay
    .map(heading => ({
      heading,
      hits: resultsByHeadings[heading],
    }))
    .filter(({ hits }) => hits.length > 0)
}
